import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { matchBreakpoint } from '../../../theme/getters';
import { Breakpoints } from '../../../theme/media';
import { renderWhenNotNil } from '../../utils/rendering';

export const DotSeparatedTitle = ({ mainText, secondaryText, theme }) => {
  const separator = matchBreakpoint(Breakpoints.TABLET)({ theme }) ? ' ● ' : <br />;
  return (
    <Fragment>
      {mainText}
      {renderWhenNotNil(() => separator)(secondaryText)}
      {renderWhenNotNil(() => secondaryText)(secondaryText)}
    </Fragment>
  );
};

DotSeparatedTitle.propTypes = {
  mainText: PropTypes.string,
  secondaryText: PropTypes.string,
  theme: PropTypes.object,
};
